<template>
    <div class="tips paperIndex-info">
        <p class="tips-title infos">温馨提示</p>
        <div class="hint" v-for="(item,index) in tips" :key="index">{{ item }}</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tips: []
        }
    },
    props:{
        // 是否禁用文本框
        type: {
            type: String,
            // false
            default: ""
        }
    },
    created () {
        this.getTips();
    },
    methods: {
        getTips() {
        // 温馨提示
          this.$api.get(this.$url.companyRefund.getTips, {type: this.type}).then(res => {
              if (res) {
                this.tips = res;
              }
            });
        },
    }
}



</script>

<style lang="less" scoped>
.tips {
  padding: 10px 20px;
  .tips-title {
    margin-bottom: 10px;
  }
}
.infos {
  color: #111;
}
.hint {
  font-size: 16px;
  color: #666;
  line-height: 26px;
}
.paperIndex-info {
  margin: 0 16px;
  font-size: 16px;
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  color: #666;
  padding: 20px;
}
</style>